<template>
	<section>
		<mu-row class="sys_title">
			<mu-col width="15" tablet="15" desktop="15">&nbsp;</mu-col>
			<mu-col width="70" tablet="70" desktop="70" class="sys_title">
				<mu-row>
					<mu-col span="5">
						<mu-chip backgroundColor="rgba(255, 255, 255, 1)" style="marginTop:-8px">
							<mu-avatar backgroundColor="rgba(0,0,0,0)" :size="70"><img src="/static/img/logo.png" /></mu-avatar>
							<span style="font-size:2.2em;font-weight:bolder;color:#505050;">智慧济南时空大数据平台(公众版)</span>
						</mu-chip>
					</mu-col>
					<mu-col span="3"></mu-col>
					<mu-col span="4">
						<div backgroundColor="rgba(255, 255, 255, 1)" style=" color:#2363B5; position: absolute; right:20px; margin-top: -25px;padding:0 30px;cursor: default">
							<template v-if="userInfo">
								<div class="user-detail">
									<span class="user-name" @click="openNewWindow(UserCenterLocation + '#0')">{{ username }}&nbsp;&nbsp;</span>
									|
									<span @click="openNewWindow(UserCenterLocation + '#1')">
										<span>
											&nbsp;我的消息&nbsp;
											<span class="user-count" v-if="userMsgCount">{{ '(' + userMsgCount + ')' }}&nbsp;</span>
										</span>
									</span>
									|
									<span @click="logout">&nbsp;注销登录</span>
								</div>
							</template>
							<template v-else>
								<div class="user-detail">当前用户：游客|登录</div>
							</template>
						</div>
					</mu-col>
				</mu-row>
			</mu-col>
			<mu-col width="15" tablet="15" desktop="15">&nbsp;</mu-col>
		</mu-row>
		<mu-row class="main_nav">
			<mu-col width="15" tablet="15" desktop="15">&nbsp;</mu-col>
			<mu-col width="70" tablet="70" desktop="70">
				<mu-tabs value="tab0" class="main_nav">
					<template v-for="(item, index) in modules">
						<mu-tab :title="item.name" :key="item.pkid" :index="item.pkid" @click="openNewWindows(item.href,item.name)"
						 :value="setValue(index)"></mu-tab>
					</template>
				</mu-tabs>
			</mu-col>
			<mu-col width="15" tablet="15" desktop="15">&nbsp;</mu-col>
		</mu-row>
		<div style="background: url(/static/img/bg3.png) no-repeat  center;padding-bottom: 2%;">
			<mu-row>
				<mu-col width="20" tablet="20" desktop="20" />
				<mu-col width="60" tablet="60" desktop="60">
					<el-tabs type="border-card" @tab-click="changeThemeTabs">
						<el-tab-pane v-for="(item, index) in ThemesType" :key="item" :label="item">
							<div v-for="(item, index) in showThemes" :key="index" style="float: left;width: 33%;position: relative;">
								<a href="javascript:void(0);" target="_blank" @click="openNewWindows(item.url,item.name)">
									<img :src="item.imgUrl" style="width: 327px;height: 213px;" />
									<div class="themesName">{{ item.name }}</div>
								</a>
								<div class="themesInfo">
									<div>系统名称：{{ item.name }}</div>
									<div>所属部门：{{ item.source }}</div>
									<div>创建日期：{{ item.date }}</div>
								</div>
							</div>
						</el-tab-pane>
					</el-tabs>
				</mu-col>
				<mu-col width="20" tablet="20" desktop="20" />
			</mu-row>
		</div>
		<div class="foot" style="position: fixed;width: -webkit-fill-available;bottom: 0px;">
			<div class="col-md-12 rows">
				<div class="footHrefOuter">
					<p class="footHref3" style="background: rgb(204, 204, 204); font-size: 12px;">
						<span>
							版权所有@ 2008-2018 济南市自然资源和规划局 技术支持：北京超图股份有限公司
						</span>
					</p>
				</div>
			</div>
		</div>
	</section>
</template>
<script type="text/javascript">
	import axios from 'axios';
	import $ from 'jquery';
	import {
		getUserMessage
	} from '@/apis/api';
	import {
		Geoesbmengine,
		Usercenter,
		Cas,
		Nav,
		Editmanager,
		Map,
		Webframe,
		dataThemesConfig
	} from '@/config/app-config';
	axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
	axios.defaults.withCredentials = true;
	let host = APPCONFIG.IP,
	casLogout = Cas.location + '/logout';
	export default {
		components: {},
		data() {
			return {
				modules: [],
				dataThemes: dataThemesConfig,
				usershortname: '游客',
				userMsgCount: 0,
				active: dataThemesConfig[0].theme,
				servicesInfos: [],
				Themes2: [],
				Themes3: [],
				Themes4: [],
				jichuGN: [],
				AllThemes: [],
				showThemes: [],
				themesIndex: '',
				host: host,
				userid: '',
				userInfo: null,
				username: '游客',
				UserCenterLocation: Usercenter.location,
				EditManagerLocation: Editmanager.location,
				loginTextShow: true,
				supervisePoints: [],
				ThemesType: ['全部', '典型应用', '特色应用', '平台应用服务', '应用案例']
			};
		},
		created() {
			setInterval(this.getUserMessage, 20000);
		},
		watch: {
			active(val) {
				this.getServicesInfo(val);
			},
			themesIndex(val) {

				switch (val) {
					case '0':
						this.showThemes = this.AllThemes;
						break;
					case '1':
						this.showThemes = this.Themes4;
						break;
					case '2':
						this.showThemes = this.Themes3;
						break;
					case '3':
						this.showThemes = this.Themes2;
						break;
					case '4':
						this.showThemes = this.Themes5;
						break;
					default:
						break;
				}
				let newArr = [];
				this.showThemes.forEach(item => {
					if (item.imgUrl.indexOf('null') != -1) {
						item.imgUrl = '../../static/img/theme.png';
					}
				});
				var i, j, len = this.showThemes.length;
				for (i = 0; i < len; i++) {
					for (j = i + 1; j < len; j++) {
						if (this.showThemes[i].name == this.showThemes[j].name) {
							this.showThemes.splice(j, 1);
							len--;
							j--;
						}
					}
				}
			}
		},
		methods: {
			changeThemeTabs(e) {
				this.themesIndex = e.index;
			},
			search() {
				alert('功能完善中...');
			},
			changeTabs(val) {
				this.active = val;
			},
			getUserInfo() {
				let that = this;
				axios.get(APPCONFIG.GetUserInfoUrl).then(function(e) {
					if (e.data && e.data.resultInfo) {
						that.userInfo = e.data.resultInfo.data;
						that.userid = e.data.resultInfo.data.pkid;
						that.username = e.data.resultInfo.data.usershortname;
						that.loginTextShow = false;
						that.getMapModule(that.userid);
					}
				});
			},
			returnAlert() {
				alert('功能完善中...');
			},
			openNewWindow(location) {
				if (location.indexOf('no_no') > -1) {
					alert('功能完善中...');
				} else {
					if (location.indexOf(window.location.host) == -1 && name.indexOf('三维辅助决策系统') != -1) {
						location = location.replace('10.210.97.189:8080', '172.16.100.81:18080')
					}
					if (location.indexOf(window.location.host) == -1 && name.indexOf('招拍挂汇报系统') != -1) {
						location = location.replace('10.210.97.189:8080', '172.16.100.81:18080')
					}
					window.open(location, '_blank');
				}
			},
			openNewWindows(location, name) {
				// debugger
				if (location.indexOf('no_no') > -1) {
					alert('功能完善中...');
				} else {
					if (location.indexOf(window.location.host) == -1 && name.indexOf('三维辅助决策系统') != -1) {
						location = location.replace('10.210.97.189:8080', '172.16.100.81:18080')
					}
					if (location.indexOf(window.location.host) == -1 && name.indexOf('招拍挂汇报系统') != -1) {
						location = location.replace('10.210.97.189:8080', '172.16.100.81:18080')
					}
					window.open(location, '_blank');
				}
			},
			setValue(index) {
				return 'tab' + index;
			},
			returnImgUrl(pkid) {
				return APPCONFIG.serviceImgUrl + pkid;
			},
			returnErrorUrl() {
				return APPCONFIG.host + '/skywebframe/images/404.png';
			},
			getUserMessage() {
				if (this.userInfo) {
					getUserMessage().then(res => {
						let result = res.data.resultInfo;
						if (result.success) {
							let count = result.data.sum;
							if (count > 99) {
								this.userMsgCount = '99+';
							} else {
								this.userMsgCount = count;
							}
						}
					});
				}
			},
			getMapModule(id) {
				let that = this;
				axios.get(APPCONFIG.GetMoudlesUrl + id + '.json').then(function(e) {
					if (e.data && e.data.data) {
						that.modules = e.data.data.modules[0].children[0].children;
					}
				});
			},
			scrollHtml(len) {
				var h = $(window).scrollTop(); //获取当前滚动条距离顶部的位置
				$('html,body').animate({
					scrollTop: document.getElementById(len).offsetTop - 50
				}, 800); //点击按钮向下移动800px，时间为800毫秒
			},
			getServicesInfo(themeId) {
				var that = this;
				axios.get(APPCONFIG.GetServicesUrl + '?pagesize=10&pageindex=1&specCode=' + themeId).then(function(e) {
					if (e.data && e.data.resultInfo) {
						that.servicesInfos = e.data.resultInfo.data.items;
						if (that.servicesInfos.length > 4) that.servicesInfos.length = 4;
					}
				});
			},
			returnStyle(url) {
				return 'background: url(' + url + ') no-repeat';
			},
			logout() {
				let url = this.userInfo ? casLogout + '?userid=' + this.userInfo.pkid : casLogout;
				window.location.href = url;
			},
			createArr(pkid, fun) {
				let that = this;
				axios.get(APPCONFIG.GetNewMoudleUrl + '/' + pkid + '.json').then(function(e) {
					if (e.data.resultInfo && e.data.resultInfo.data && e.data.resultInfo.data.items) {
						let themes = e.data.resultInfo.data.items;
						themes.forEach((item, index) => {
							let obj = {};
							obj.url = item.descinfo;
							obj.name = item.nttitle;
							obj.imgUrl = host + item.imageurl;
							obj.source = item.ntsource;
							obj.date = item.ntdate;
							fun(obj);
						});
					}
				});
			}
		},
		mounted() {
			let that = this;
			this.getUserInfo();
			this.getServicesInfo(dataThemesConfig[0].theme);
			$('#J-ali-main-specail li').hover(
				function() {
					$(this)
						.removeClass()
						.addClass('hover');
				},
				function() {
					$(this).removeClass();
				}
			);
			$('.cloud1').on('click', function() {
				//_self.common.scroll('#cloud', 1000);
				window.open('/map', '_blank');
			});
			axios.get(APPCONFIG.GetNewsUrl).then(function(e) {
				// debugger
				if (e.data.resultInfo && e.data.resultInfo.data && e.data.resultInfo.data.items) {
					let newsmoudels = e.data.resultInfo.data.items;
					that.AllThemes = [];
					newsmoudels.forEach((item, index) => {
						if (item.name == '典型应用') {
							that.Themes4 = [];
							that.createArr(item.pkid, function(obj) {
								that.Themes4.push(obj);
								that.AllThemes.push(obj);
							});
						} else if (item.name == '特色应用') {
							that.Themes3 = [];
							that.createArr(item.pkid, function(obj) {
								that.Themes3.push(obj);
								that.AllThemes.push(obj);
							});
						} else if (item.name == '平台应用服务') {
							that.Themes2 = [];
							that.createArr(item.pkid, function(obj) {
								that.Themes2.push(obj);
								that.AllThemes.push(obj);
							});
						} else if (item.name == '应用案例') {
							that.Themes5 = [];
							that.createArr(item.pkid, function(obj) {
								that.Themes5.push(obj);
								that.AllThemes.push(obj);
							});
						} else if (item.name == '对接应用') {
							that.Themes4 = [];
							that.createArr(item.pkid, function(obj) {
								that.Themes4.push(obj);
								that.AllThemes.push(obj);
							});
						}
					});
					that.AllThemes.forEach(item => {
						if (item.imgUrl.indexOf('null') != -1) {
							item.imgUrl = '../../static/img/theme.png';
						}
					})
				}
			});
			setTimeout(() => {
				this.themesIndex = '0';
			}, 1000);
		}
	};
</script>
<style type="text/css">
	.nav_3_img .mu-card-header-title .mu-card-title {
		font-size: 20px;
	}

	.media-body h4 {
		font-size: 18px;
	}

	.themesName {
		position: absolute;
		bottom: 30%;
		left: 1.5%;
		color: white;
		width: 81%;
		height: 25%;
		background-color: rgba(128, 128, 128, 0.8);
		font-size: 23px;
		font-weight: bold;
		padding-left: 5%;
		padding-top: 2%;
	}

	.themesInfo {
		padding-left: 4%;
	}

	.media-body p {
		font-size: 14px;
	}

	/* navigation
-------------------------------------------------- */
	.navigation .ali-main-special {
		position: relative;
		width: 100%;
		height: 120px;
		padding: 0px;
		margin: 30px 0;
		text-align: right;
	}

	.navigation .ali-main-special .media {
		cursor: pointer;
	}

	.navigation .ali-main-special li {
		position: relative;
		height: 120px;
		display: block;
		width: 20%;
		float: left;
	}

	.navigation .ali-main-special .hover h4 {
		color: #004d8c;
	}

	.navigation .ali-main-special li:before,
	.navigation .ali-main-special li:after {
		content: '';
		position: absolute;
		width: 1px;
		height: 100%;
		background: #d8d8d8;
		top: 0;
		z-index: 2;
	}

	.navigation .ali-main-special li:before {
		left: 0;
		margin-left: -1px;
	}

	.navigation .ali-main-special li:after {
		right: 0;
	}

	.navigation .ali-main-special li a {
		padding: 0 1px;
		display: block;
		width: 100%;
		height: 100%;
	}

	.navigation .ali-main-special li .bg-item {
		-webkit-transition: all 0.3s;
		-moz-transition: all 0.3s;
		-o-transition: all 0.3s;
		transition: all 0.3s;
		position: absolute;
		top: -17px;
		left: 6px;
	}

	.navigation .ali-main-special li .bg-normal {
		width: 100%;
		opacity: 1;
		-ms-filter: 'progid:DXImageTransform.Microsoft.Alpha(Opacity=100)';
	}

	.navigation .ali-main-special li .bg-hover {
		width: 100%;
		opacity: 0;
		-ms-filter: 'progid:DXImageTransform.Microsoft.Alpha(Opacity=0)';
	}

	.navigation .ali-main-special li.hover .bg-normal {
		opacity: 0;
		-ms-filter: 'progid:DXImageTransform.Microsoft.Alpha(Opacity=0)';
	}

	.navigation .ali-main-special li.hover .bg-hover {
		opacity: 1;
		-ms-filter: 'progid:DXImageTransform.Microsoft.Alpha(Opacity=100)';
	}

	.navigation .media-body {
		padding-left: 120px;
		text-align: left;
		padding-top: 25px;
	}

	.navigation .media-body a {
		color: rgb(34, 34, 34);
	}

	/*--------------------------------------------------------------------*/
	.mu-tab-active {
		color: red !important;
	}

	body {
		min-width: 1910px;
		overflow-x: auto !important;
	}

	.user-detail span {
		cursor: pointer;
	}

	.card-back-url {
		padding: 10px;
	}

	#app .foot div .footHrefOuter .footHref3 {
		text-align: center;
		height: 30px;
		line-height: 30px;
	}

	.erweima {
		margin-top: 25px;
		padding: 10px 10px 10px 0;
	}

	.liaojiedesc {
		margin-top: 25px;
		background-color: #ffcd74;
		width: 130px;
		text-align: center;
		color: #fff;
		cursor: pointer;
		font-size: 24px;
		font-weight: 900;
		border-radius: 5px;
		box-shadow: 0 0 5px 5px #888888;
	}

	.mu-card-header {
		cursor: pointer;
	}

	.textdesc ul li {
		color: #fff;
		font-size: 18px;
		padding: 8px;
	}

	.textdesc h5 {
		font-size: 20px;
		color: #fff;
	}

	.textdesc {
		margin-top: 50px;
	}

	.finger {
		background: url(/static/img/finger.png) no-repeat;
		height: 532px;
	}

	.phone-title {
		text-align: center;
		font-weight: 900;
		font-size: 25px;
		color: #fff;
		height: 80px;
		line-height: 100px;
		border-bottom: 5px solid #fff;
	}

	.phone-background {
		width: 100%;
		height: 637px;
		min-height: 637px;
		background: url(/static/img/phoneback2.png) no-repeat;
		background-size: cover;
		margin-top: 50px;
	}

	.el-divider__text {
		font-size: 25px !important;
		font-weight: 900 !important;
		color: #ff5a69 !important;
		font-family: inherit !important;
		font-weight: 500 !important;
		line-height: 1.1 !important;
	}

	.sys_pingtai {
		height: 265px;
		padding: 20px 0;
		margin-top: 10px;
	}

	.el-input-group__append {
		border-left: 1px solid #dcdfe6 !important;
		background-color: #5099ea !important;
		color: #fff !important;
		border-radius: 25px !important;
		padding: 0 5px !important;
	}

	#nav_col_img .mu-card-header-title {
		vertical-align: inherit;
	}

	.nav_3_img .mu-card-header {
		text-align: center;
	}

	.nav_3_img .mu-card-header .mu-avatar img {
		border-radius: 1%;
	}

	.nav_3_img .mu-card-header .mu-card-header-title {
		padding-right: 18px;
		border-radius: 1%;
		display: block;
		text-align: center;
	}

	.el-input__inner {
		border-radius: 25px !important;
		height: 30px !important;
		line-height: 30px !important;
	}

	.mu-card-header-title .mu-card-title {
		font-size: 18px;
	}

	.mu-tab-link-highlight {
		border-radius: 25px;
		height: 3px;
		/* background-color: #fff;*/
	}
</style>
<style scoped>
	.mu-tab-link {
		border-bottom: 3px rgba(0, 0, 0, 0) solid;
	}

	.mu-tab-link:hover {
		border-bottom: 3px red solid;
		transition: transform 0.3s, opacity 0.3s;
	}

	#nav_4_img .mu-card-header .mu-avatar img {
		border-radius: 1%;
	}

	#nav_col_img .mu-card-header .mu-avatar img {
		border-radius: 20%;
		width: 50px;
		height: 50px;
	}

	.el-button {
		color: #fff;
		border-radius: 25px;
	}

	.el-input {
		padding: 5px;
		width: 98%;
		/*background-color: #7572728a;
    border: 1px solid #8c7e7e;*/
		border-radius: 25px;
		caret-color: #fff;
	}

	.sys_title {
		background: url('/static/img/top-pic.png') no-repeat center top;

		height: 95px;
		margin-top: 20px;
	}

	.username {
		float: left;
	}

	.bar-name {
		color: white;
	}

	.row-left {
		border-right: 1px dashed rgba(0, 0, 0, 0.1);
	}

	.menu-active {
		border-left: 2px solid lightblue;
	}

	.board-left,
	.board-right {
		padding: 5px;
	}

	.paper-draft {
		padding: 10px;
	}

	.list-menu {
		background: #eeeeee;
	}

	.sys_header,
	.header_user {
		background-color: #fff;
		color: #4e2594;
		height: 78px;
	}

	.sys_header .mu-paper-1 {
		box-shadow: none;
		line-height: 32px;
	}

	.sys_header .mu-tab-active {
		color: #333;
	}

	.sys_header .mu-tab-link {
		color: rgba(12, 67, 95, 0.7);
	}

	.sys_header_tabs {
		width: 50%;
	}

	.sys_banner {
		height: 54vh;

		background-color: #83aedb;
		text-align: center;
	}

	.sys_banner img {
		height: 100%;
	}

	.banner_nav {
		height: 60px;
		font-size: 33px;
	}

	.banner_bottom {
		margin-top: -10px;
		background-color: #83aedb;
	}

	.head_sub_nav {
		background-color: #fff;
		padding: 4px auto;
	}

	.left {
		flaot: left;
	}

	.main_nav {
		height: 50px;
		font-size: 20px;
		background-color: #5099ea;
	}

	.main_nav .mu-tab-text {
		color: #fff;
	}

	.banner_nav_col {
		padding: 20px 0px;
	}

	.service_nav {
		background-color: #fff;
		color: #4e2594;
	}

	.service_nav .mu-tab-link {
		color: #666;
	}

	.main_nav .mu-tab-link {
		font-size: 16px;
	}

	.service_tabs_content.mu-paper-1,
	.no_shadow {
		background-color: rgba(0, 0, 0, 0) !important;
		box-shadow: none;
		line-height: 32px;
	}

	.service_tabs_content.mu-paper-1 .service_item {
		width: 20%;
		float: left;
		cursor: pointer;
		margin: 0 2.5%;
	}

	.service_tabs_content.mu-paper-1 .service_item:hover {
		width: 20%;
		float: left;
		cursor: pointer;

		height: 95%;
		margin: 0 2.5%;
		margin-top: -2px;
		box-shadow: 0 10px 10px 10px #888888;
	}

	.bg_h {
		padding: 20px 0px;
		/*  background-color: #fff*/
	}
</style>



// WEBPACK FOOTER //
// yymore.vue?81df493e